"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _modalLoader = require("@wsb/modal-loader");
var _constants = require("./constants");
var namespace = _constants.APP_NAMESPACE;
var loaderConfig = {
  appConfigKey: namespace,
  appKey: namespace,
  cdnVirtualPath: "blobby/go/static/engagement/".concat(namespace),
  hasBundledCss: true,
  namespace: namespace,
  renderMode: _modalLoader.RenderMode.MODAL,
  versionKey: 'difyLeadGenLiveVersion'
};
var _default = exports.default = loaderConfig;